<template>
  <div v-if="validationState.$dirty">
    <p
      v-for="param in validationParams"
      :key="param.name"
      :class="$style.error"
    >
      {{ $t(validationMessage(param)) }}
    </p>
  </div>
</template>
<script>
export default {
  name: "field-error-messages",
  props: {
    validationState: { type: Object, required: true },
    validationMessages: { type: Object, default: () => ({}) },
    showAll: { type: Boolean, default: false }
  },
  computed: {
    validationParams() {
      let errorMessages = this.validationState.$flattenParams()
        .filter(param => this.getIsValidState(this.validationState, param) === false);

      if (this.showAll) {
        return errorMessages;
      }

      return errorMessages.length ? [errorMessages[0]] : [];
    }
  },
  methods: {
    getIsValidState(validationState, param) {
      if (param.path.length) {
        return validationState[param.path][param.name];
      }

      return validationState[param.name];
    },
    validationMessage(param) {
      return this.validationMessages[param.name] || "validations_field_" + param.name;
    }
  }
};
</script>

<style module lang="scss">
//@import "~@bvm/forms/src/style/abstract/abstract.colors";
$color-attention: #dc143c;
$spacing-s: 15px;

.error {
  line-height: 1.3125;
  font-size: rem-calc(15);
  color: $color-attention;
  margin-top: rem-calc($spacing-s);
}
</style>
